import { type JSX } from "react";
import { type Field } from "@sitecore-content-sdk/nextjs";
import { ComponentProps } from "lib/component-props";

export type SkipLinkFields = {
  Title?: Field<string>;
  ContentID?: Field<string>;
};

export type SkipLinkProps = ComponentProps & {
  fields?: SkipLinkFields;
};

export const Default = (props: SkipLinkProps): JSX.Element => {
  console.log("---->[SkipLink] Component", props.fields);

  const { fields } = props;

  return (
    <a
      className="skip-link absolute left-[-999px] top-3 z-50 rounded-0 bg-gray-200 px-4 py-3 text-base text-black no-underline text-[14px] leading-[20px] font-normal text-text-gray
        focus:left-2 focus:outline-none focus:ring-2 focus:ring-black focus:rounded-[1px] focus:ring-offset-2 focus:ring-offset-white
        focus:text-gray-deep focus:bg-gray-soft focus:font-medium focus:leading-normal"
      data-role="skip-link-component"
      href={`#${fields?.ContentID?.value ?? ""}`}
      tabIndex={0}
      aria-label="Skip to content"
    >
      {fields?.Title?.value}
    </a>
  );
};
